import React from 'react';
import { IconProps } from '../types';
const MinecraftMutton: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="11" y="1" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(173, 51, 46, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(221, 56, 48, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(209, 46, 38, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(226, 98, 90, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(232, 138, 130, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(226, 114, 105, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(188, 41, 34, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(150, 33, 27, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(71, 10, 6, 255)" />
</svg>);
export default MinecraftMutton;